/**
 * Created by bing on 2018/3/30.
 */
module.exports = function (Vue) {
    Vue.prototype.globalData = {
        // host: 'http://localhost:8033',
        // host: '//3i-demo.smartfact.cn',
        resourceUrl:'/',


        host: '',
        // host: 'http://127.0.0.1:8012',
        // feestate:['正常','催费','欠费'],
        // relaystate:['拉闸','合闸','催费'],
        // runstate:['未运行','运行','销户'],
        companyMonitorType: {
            1: '固定时间（每天）',
            2: '固定间隔(分钟)'
        },
        priceType: {
            1: "普通",
            2: "尖峰平谷"
        },
        ladderTypeList: {
            1: '年',
            2: '月'
        }
        ,

        feestateList: {
            1: '正常',
            2: '催费',
            3: '欠费'
        }
        ,

        taskStatusList: {
            1: '新建',
            2: '执行中',
            3: '完成',
            4: '失败'
        }
        ,
        relaystateList: {
            1: '合闸',
            2: '拉闸'
        },

        conRunStatus: {
            1: '已连接',
            0: '未连接'
        },
        dayAcountTabStatus: {
            1: '成功',
            2: '等待中',
            3: '失败',
            4:'集中器不在线'
        },


        runstateList: [
            // {id:0,name:'未运行'},
            // {id:1,name:'运行'},
            // {id:2,name:'销户'},
        ],
        pay: ['管理员','微信',  '支付宝'],
        intype: ['日冻结', '开户', '换表'],
        paytype: {1: '管理员充值',2:'微信充值', 3:'支付宝充值'},
        MonitorType: ['DTU', '485']

    }
};



// WEBPACK FOOTER //
// ./src/global/data.js